<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-base font-medium">Network logs</h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="min-h-[100px] p-4">
        <div class="sticky top-0 h-0 w-full">
          <FreeButton
            class="gray-button ml-auto"
            size="sm"
            @click="emit('onClearLogs')"
          >
            Clear
          </FreeButton>
        </div>
        <h3 v-if="isEmptyLogs" class="my-auto space-y-4 text-center">
          No logs yet. Try to send requests
        </h3>
        <div v-else class="space-y-4">
          <NetworkLogData
            v-for="(log, id) of networkLogs"
            :key="id"
            :log-data="log"
            @click="emit('onLogSelect', id)"
          />
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import {
    FreeBottomSheet,
    FreeButton,
    FreeCloseButton,
    FreeHeader,
  } from 'freedom-shared';

  import type { NetworkLog } from '../../../entities/network-log';
  import NetworkLogData from './NetworkLogData.vue';

  const props = defineProps<{
    name: string;
    networkLogs: Record<string, NetworkLog>;
  }>();

  const emit = defineEmits<{
    onClearLogs: [];
    onLogSelect: [string];
  }>();

  const isEmptyLogs = computed(
    () => Object.keys(props.networkLogs).length === 0,
  );
</script>
